import { useContext } from 'react';
import { MapContext } from '../../../context/MapContext';
import { useDrag } from '@use-gesture/react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './Popup.css';

export default function Popup() {
	const {
		popupOpen,
		setPopupOpen,
		popupData,
		popupPosition,
		setPopupPosition,
		popupBind,
		setPopupBind,
	} = useContext(MapContext);

	const bind = useDrag((ele) => {
		setPopupBind({
			x: ele.offset[0],
			y: ele.offset[1],
		});

		let x = ele.offset[0] - popupBind.x + popupPosition.x;
		let y = ele.offset[1] - popupBind.y + popupPosition.y;

		setPopupPosition({
			x: x,
			y: y,
		});
	});

	const onClickPopBtn = () => {
		setPopupOpen(false);
	};

	return (
		<>
			{popupOpen ? (
				<div
					{...bind()}
					className="pointIDModal"
					style={{
						top: `${popupPosition.y + 90}px`,
						left: `${popupPosition.x - 230}px`,
					}}
				>
					<header>
						<h1>격자 ID: {popupData?.id}(시도: {popupData?.sido_nm}, 시군구: {popupData?.sgg_nm})</h1>
						<IconButton className="closeIconButton" onClick={onClickPopBtn}>
							<CloseIcon style={{ fontSize: '1.4rem' }} />
						</IconButton>
					</header>
					<div className="popupList">
						<div className="popupItem" style={{ marginRight: '2%' }}>
							<ul>
								<li>
									<h2>총가구수</h2>
									<span>{popupData?.toH.toLocaleString('ko-KR')}가구</span>
								</li>
								<li>
									<h2 style={{ color: '#366FE0' }}>1인가구수</h2>
									<span style={{ color: '#366FE0' }}>
										{popupData?.oneH.toLocaleString('ko-KR')}가구
									</span>
								</li>
								<li className="rat">
									<h2 style={{ color: '#366FE0' }}>1인가구 비중</h2>
									<span style={{ color: '#366FE0' }}>
										{((popupData?.oneH / popupData?.toH) * 100).toFixed(2)}%
									</span>
								</li>
							</ul>
						</div>
						<div className="popupItem pop">
							<div className="tit">
								<h2>거주인구수</h2>
								<span>
									{popupData?.allPop.toLocaleString('ko-KR', {
										minimumFractionDigits: 0,
										maximumFractionDigits: 0,
									})}
									명
								</span>
							</div>
							<div className="sub">
								<li className="pop">
									<h2>15~49세 인구수</h2>
									<span>
										{popupData?.pop_49.toLocaleString('ko-KR', {
											minimumFractionDigits: 0,
											maximumFractionDigits: 0,
										})}
										명
									</span>
								</li>
								<li className="pop">
									<h2>65세 이상 인구수</h2>
									<span>
										{popupData?.pop_65.toLocaleString('ko-KR', {
											minimumFractionDigits: 0,
											maximumFractionDigits: 0,
										})}
										명
									</span>
								</li>
								<li className="pop">
									<h2>75세 이상 인구수</h2>
									<span>
										{popupData?.pop_75.toLocaleString('ko-KR', {
											minimumFractionDigits: 0,
											maximumFractionDigits: 0,
										})}
										명
									</span>
								</li>
							</div>
						</div>
					</div>
					<div className="exp">
						<span>
							※ SGIS 격자 데이터는 개인정보보호를 위해 통계청 비밀보호기법이
							적용되어 제공되는 값이 실제 값과 다를 수 있습니다. 자세한 내용은
							'데이터 출처, 유의사항 보기'를 통해 확인해 주세요.
						</span>
					</div>
				</div>
			) : null}
		</>
	);
}
